<template>
  <div id="app">
    <Topbar></Topbar>
    
      <router-view/>
    </div>
    

</template>

<script>
import axios from "axios";
import Topbar from "@/components/Topbar.vue";

export default {
  components: { Topbar },
  data() {
    return {};
  },
  methods: {
    loadAdminData() {
      var _this = this;
      axios
        .get(
          "https://sportips.fr/api/v1/unique_event/endpoints/admin/get.php?id=" +
            this.$store.state.module.id
        )
        .then(function (response) {
          _this.$store.commit("initAdmin", response.data);
          _this.$root.$el.style.setProperty(
            "--primary-color",
            _this.$store.state.admin.primary_color
          );
          _this.$root.$el.style.setProperty(
            "--background-color",
            _this.$store.state.admin.background_color
          );
          _this.$root.$el.style.setProperty(
            "--footer-color",
            _this.$store.state.admin.footer_color
          );
          _this.$root.$el.style.setProperty(
            "--header-image",
            "url('" + _this.$store.state.admin.header_url + "')"
          );
          _this.$root.$el.style.setProperty(
            "--footer-image",
            "url('" + _this.$store.state.admin.footer_url + "')"
          );
          _this.$forceUpdate();
        });
    },
  },
  mounted() {
    var _this = this;
    axios
      .get(
        "https://sportips.fr/api/v1/unique_event/endpoints/module/get.php?base=" +
          this.$route.params.base
      )
      .then(function (response) {
        _this.$store.state.module = response.data;
        if (_this.$store.state.module.id) {
          _this.loadAdminData();
        }
      });
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rubik:wght@400;500;700&display=swap");

html{
  background-color: #36424e;
}
#app {
  --primary-color: #f29200;
  --background-color: #36424e;
  --footer-color: #2f3a45;
  --header-image: url("https://sportips.fr/race/uploads/topbar_bg.jpg");
}

@import "./scss/style.scss";
</style>
